/* eslint-disable func-style */
/* eslint-disable camelcase */
import { formatMoney } from "//auriccosmetics.com/cdn/shop/t/46/assets/currency.js?v=6251057577833845111762287288";
import { reflow } from "//auriccosmetics.com/cdn/shop/t/46/assets/dom.js?v=175014698423836044041762287288";
import { updateQuantityNumber, initInputs } from "//auriccosmetics.com/cdn/shop/t/46/assets/quantity-input.js?v=87715063683911766691762287288";
import { hideButton, showButton, enableButton, disableButton } from "//auriccosmetics.com/cdn/shop/t/46/assets/dom.js?v=175014698423836044041762287288";

export const SELECTORS = {
  CART: 'header-cart',
  SECTION: 'cart',
  PRICE: 'cart__footer-total',
  REMOVE: '.cart__remove',
  QUANTITY_INPUT: '.cart__quantity input[name="updates[]"]',
};

export const MINIATURE_WIDTH = 32;

export const addToCart = (options = {}) => {
  return $.post(`${window.Shopify.routes.root}cart/add.js`, options, null, 'json');
};

export const getCart = () => {
  return $.get(`${window.Shopify.routes.root}cart.js`, null, null, 'json');
};

export const setCartText = (text) => {
  const cartCounter = document.getElementById('cartCounter');
  if (cartCounter) {
    cartCounter.textContent = text ? text : '';
  }
};

export const updateCartCounter = () => {
  return getCart().done(({ item_count }) => {
    setCartText(item_count);
  });
};

export const flyToCart = (imageElement) => {
  if (!imageElement) {
    return;
  }

  const cart = document.querySelector(`#${SELECTORS.CART}`);
  const { top: destinationTop, left: destinationLeft } = cart.getBoundingClientRect();

  const img = document.createElement('img');
  const {
    top: sourceTop, height: sourceHeight, left: sourceLeft, width: sourceWidth
  } = imageElement.getBoundingClientRect();

  const top = sourceTop + sourceHeight / 2;
  const left = sourceLeft + sourceWidth / 2;

  img.src = imageElement.src;
  img.style.position = 'fixed';
  img.style.width = `${MINIATURE_WIDTH}px`;
  img.style.zIndex = '1000';
  img.style.top = `${top}px`;
  img.style.left = `${left}px`;
  img.style.transition = 'transform 1s ease-in-out';
  img.style.transform = 'translate3d(0, 0, 0) scale(1)';

  const offsetY = (top - destinationTop) * -1;
  const offsetX = destinationLeft - left;

  document.body.appendChild(img);

  const remove = () => {
    document.body.removeChild(img);
  };

  const animateOut = () => {
    img.style.transition = 'transform .25s ease-in-out';
    img.style.transform = `${img.style.transform} scale(0.01)`;
    setTimeout(remove, 250);
  };

  img.onload = () => {
    reflow();
    requestAnimationFrame(() => {
      img.style.transform = `translate3d(${offsetX}px, ${offsetY}px, 0) scale(1)`;
      setTimeout(animateOut, 1000);
    });
  };
};

export const onQuantityChange = (quantity, line) => {
  return $.post(`${window.Shopify.routes.root}cart/change.js`, { quantity, line }, null, 'json');
};

export const initCarts = () => {
  const sections = document.querySelectorAll(`.${SELECTORS.SECTION}`);

  sections.forEach((section) => {
    const quantityInputs = section.querySelectorAll(SELECTORS.QUANTITY_INPUT);
    const removeButtons = section.querySelectorAll(SELECTORS.REMOVE);

    const updatePrice = (section, price) => {
      const priceElement = section.querySelector(`.${SELECTORS.PRICE}`);
      if (priceElement) {
        priceElement.textContent = price;
      }
    };

    const updateCarts = ({ total_price, item_count, items }) => {
      sections.forEach((cartSection) => {
        if (cartSection !== section) {
          const quantityInputs = cartSection.querySelectorAll(SELECTORS.QUANTITY_INPUT);
          quantityInputs.forEach((input, index) => {
            input.value = items[index].quantity;
            updateQuantityNumber(input);
          });
        }

        updatePrice(cartSection, formatMoney(total_price, theme.moneyFormat));
      });

      setCartText(item_count);
    };

    const updateAddToCartButton = ({ button, quantity, hide }) => {
      if (!button) {
        return;
      }

      const maxQuantity = button.dataset.maxQuantity;

      if (quantity >= maxQuantity) {
        if (hide) {
          hideButton(button);
        } else {
          disableButton(button);
        }
      } else if (hide) {
        showButton(button);
      } else {
        enableButton(button);
      }
    };

    quantityInputs.forEach((input, index) => {
      input.addEventListener('change', () => {
        onQuantityChange(input.value, index + 1).done((data)=> {
          updateCarts(data);
        });
      });
    });

    removeButtons.forEach((button, index) => {
      button.addEventListener('click', async (ev) => {
        ev.preventDefault();
        const data = await onQuantityChange(0, index + 1);
        await forceCartReload();
        updateCarts(data);
      });
    });
  });
};

export function refreshCart() {
  const requestURL = `${window.Shopify.routes.root}cart`;
  return $.get(requestURL).done((data) => {
    const parsedHTML = $.parseHTML(data);
    const cart = $(parsedHTML).find(`.${SELECTORS.SECTION}`)[0];
    const carts = document.querySelectorAll(`.${SELECTORS.SECTION}`);

    carts.forEach((c) => {
      $(c).html($(cart).html());
      initInputs(c);
    });
    
    initCarts();
  });
}

export async function forceCartReload() {
  await refreshCart();
  await updateCartCounter();
}

window.addEventListener('load', forceCartReload);